import * as React from 'react';
import styled from 'styled-components';
import * as KrispyTokens from '@krispy-tokens/blue';

const KrispyLine = styled.div`
  width: 100%;
  height: 2px;
  border-radius: 1px;
  background-color: ${KrispyTokens.KrispyColorPaletteGray92};
`;

const Line = () => (
  <KrispyLine />
);

export default Line;
